import { JobPostActionType, NewJobType } from 'pages/createJob/types'
import { Dispatch, SetStateAction } from 'react'

export interface IJobProps {
  eventHandlers: {
    changeHandler?: any
    submitHandler?: () => Promise<any>
    handleSelect?: any
  }
  dispatchers?: {
    setNewJob: Dispatch<SetStateAction<NewJobType>>
  }
  newJob?: NewJobType
  title?: string
  submitButtonTitle?: string
  descriptionWordCount: number
  disableButton: boolean
  disableUpload: boolean
  titleWordCount: number
  formType?: JobPostActionType
  isLoading?:boolean
  disableSaveBtn?:boolean
  showCancelBtn?: boolean
  isValidUrl?: boolean
  location?: string[]
  isUSOrCanada?: any
}

export enum CountryCodes {
  CA = 'CA',
  US = 'US',
}
export enum CountryNames {
  CA = 'Canada',
  US = 'United States',
  OUTSIDE_NA_SELECT_VALUE = 'Outside North America'
}

export const USOrCanadaChecks = [
  'United States',
  'Canada',
  'US',
  'CA',
]